(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whp-promo-ticket"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('whp-copy-code')) {
    customElements.define(
      'whp-copy-code',
      class WhpCopyCode extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('button');
          const label = this.querySelector('[data-label]');
          if (!button || !label) return;
          const original = label.textContent;
          button.addEventListener('click', async () => {
            const code = this.dataset.code || '';
            try {
              await navigator.clipboard.writeText(code);
            } catch (e) {
              const input = document.createElement('textarea');
              input.value = code;
              input.setAttribute('readonly', '');
              input.style.position = 'fixed';
              input.style.opacity = '0';
              document.body.appendChild(input);
              input.select();
              try { document.execCommand('copy'); } catch (err) {}
              input.remove();
            }
            label.textContent = this.dataset.done || 'Copied';
            this.classList.add('is-copied');
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
              label.textContent = original;
              this.classList.remove('is-copied');
            }, 2200);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whp-tabbed-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('whp-tabs')) {
    customElements.define(
      'whp-tabs',
      class WhpTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          if (!this.tabs.length) return;
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index));
            tab.addEventListener('keydown', (event) => {
              const keys = { ArrowRight: 1, ArrowLeft: -1 };
              if (!(event.key in keys)) return;
              event.preventDefault();
              const next = (index + keys[event.key] + this.tabs.length) % this.tabs.length;
              this.select(next);
              this.tabs[next].focus();
            });
          });
        }
        select(index) {
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
            if (panel) panel.hidden = !active;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whp-vip-access"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('whp-vip-access')) {
    customElements.define(
      'whp-vip-access',
      class WhpVipAccess extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.input = this.querySelector('input[type="email"]');
          this.status = this.querySelector('.whp-access__status');
          this.label = this.querySelector('[data-label]');
          this.original = this.label ? this.label.textContent : '';
          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.verify();
          });
        }
        say(message, tone) {
          this.status.hidden = !message;
          this.status.textContent = message || '';
          this.status.dataset.tone = tone || '';
        }
        async verify() {
          const email = this.input.value.trim();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            this.say('Please enter a valid email address.', 'error');
            this.input.focus();
            return;
          }
          this.say('', '');
          if (this.label) this.label.textContent = 'Checking…';
          this.form.querySelector('button').disabled = true;
          try {
            const response = await fetch(this.dataset.endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email, shop_id: this.dataset.shop }),
              cache: 'no-store',
            });
            const data = await response.json().catch(() => ({}));
            const result = data && (data.Result || data.result);
            if (response.ok && result && result.active === true) {
              const value = encodeURIComponent(this.dataset.key || '');
              document.cookie = 'hp_vip_access=' + value + '; path=/; max-age=86400; SameSite=Lax';
              this.say('You’re in. Opening the VIP collection…', 'ok');
              window.location.href = this.dataset.next;
              return;
            }
            this.say(response.ok && result ? this.dataset.msgInactive : this.dataset.msgError, 'error');
          } catch (e) {
            this.say(this.dataset.msgError, 'error');
          }
          if (this.label) this.label.textContent = this.original;
          this.form.querySelector('button').disabled = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whp-vip-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.whpJoinBound) {
  window.whpJoinBound = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-whp-join]');
    if (!form) return;
    event.preventDefault();
    const id = Number(form.querySelector('[name="id"]').value);
    const label = form.querySelector('[data-label]');
    const original = label ? label.textContent : '';
    if (label) label.textContent = 'Adding…';
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const cart = await fetch(root + 'cart.js').then((r) => r.json());
      const inCart = cart.items.some((item) => item.variant_id === id);
      const url = root + (inCart ? 'cart/update.js' : 'cart/add.js');
      const body = inCart ? { updates: { [id]: 1 } } : { items: [{ id, quantity: 1 }] };
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (!res.ok) throw new Error('cart');
      window.location.href = root + 'cart';
    } catch (e) {
      if (label) label.textContent = original;
      form.submit();
    }
  });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whp-vip-steps"] && !Shopify.designMode) return;
  try {
    
  if (!window.whpJoinBound) {
  window.whpJoinBound = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-whp-join]');
    if (!form) return;
    event.preventDefault();
    const id = Number(form.querySelector('[name="id"]').value);
    const label = form.querySelector('[data-label]');
    const original = label ? label.textContent : '';
    if (label) label.textContent = 'Adding…';
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const cart = await fetch(root + 'cart.js').then((r) => r.json());
      const inCart = cart.items.some((item) => item.variant_id === id);
      const url = root + (inCart ? 'cart/update.js' : 'cart/add.js');
      const body = inCart ? { updates: { [id]: 1 } } : { items: [{ id, quantity: 1 }] };
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (!res.ok) throw new Error('cart');
      window.location.href = root + 'cart';
    } catch (e) {
      if (label) label.textContent = original;
      form.submit();
    }
  });
  }

  } catch(e) { console.error(e); }
})();
})();
